var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saas-404"},[_c('img',{attrs:{"src":"/images/404.png","alt":""}}),_c('div',[_c('h1',[_vm._v(_vm._s(_vm.hostName)+" 地址不正确")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('p',[_c('i'),_vm._v("请确认企业已开通服务")]),_c('p',[_c('i'),_vm._v("如企业已开通服务，请联系系统管理员确认访问地址")])])
}]

export { render, staticRenderFns }